<template>
  <div class="py-7 container-fluid">
    <div class="card">
      <div class="card-header pb-0">
        <div class="mb-3">
          <h6>Home</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>
<script>
export default {
  components: {},
  data() {
    return {
      report: Object,
    };
  },
  computed: {},
  mounted() {
  },
  methods: {
  },
};
</script>
